import React from 'react';
import {Button} from "antd";
import styled from "styled-components";
import {StyledModal} from "./StyledModal";

const CancelButton = styled(Button)`
  padding: 8px 24px 8px 24px;
  border-radius: 4px;
  color : #45505A;
  border: 1px solid #A9B3BC;
  font-size: 14px;
  font-weight: 600;
  line-height: 22px;
  text-align: center;
  height: 100%;
  &:hover {
    border-color: #A9B3BC !important;
    color: #76838F !important;
  }
`

const OkButton = styled(Button)`
  &:hover {
    background-color: #56ADF3 !important;
  }
`

type ResumeNotPublishedModalProps = {
  isOpen: boolean,
  close: () => void,
  handleNavigate: () => void
}

export const ResumeNotPublishedModal = ({isOpen, close, handleNavigate} : ResumeNotPublishedModalProps) => {
  return(
    <StyledModal
      open={isOpen}
      title="Ваше резюме пока не опубликовано"
      onOk={handleNavigate}
      onCancel={close}
      width={600}
      centered
      footer={[
        <CancelButton onClick={close} key="back">
          Отмена
        </CancelButton>,
        <OkButton type="primary" onClick={handleNavigate} key="submit">
          Заполнить резюме
        </OkButton>
      ]}
    >
      <p>Вы начали создавать резюме, но пока его не опубликовали.</p>
      <p>Вам необходимо сначала заполнить всю информацию о себе</p>
    </StyledModal>
  )
}